import ImgWithTitle from '../../component/workspaceContainer/ImgWithTitle';
import { LoginBackButton } from '../../component/buttonComponent/ButtonComponent';
import '../forgotPassword/ForgotPassword.css';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import FooterImage from '../../image/header.png'

const UnverifiedUser = () => {
    const navigate = useNavigate();
    const btnBack = (e) => {
        e.preventDefault();
        navigate('/login', { replace: true });
    };

    return (
        <div className="forgot-password-container-main">
            <div className="forgot-password-container">
                <div className='img-with-title-container'>
                    <ImgWithTitle titleText="User Not Verified" subText="You are unable to login due to your account not being verified. Please check your email and complete your verification." icon="Invalid" />
                </div>
                <LoginBackButton label="Back to log in" btnClickBack={btnBack} backgroundColor="#FFFFFF" />
            </div>
            <div className="login-logo-footer">
            <div className="login-logo">
              <img
                loading="lazy"
                src={FooterImage}
                className="logo"
                alt="header-logo"
              />
            </div>
          </div>
        </div>
    );
};

export default UnverifiedUser;